<template>
  <div class="table">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="基础资料" name="1">
        <BasicData v-if="activeName === '1'" :value="detailsData" />
      </el-tab-pane>
      <el-tab-pane label="会员资产" name="2">
        <MemberAssets v-if="activeName === '2'" :value="detailsData" />
      </el-tab-pane>
      <el-tab-pane label="其它记录" name="3">
        <OtherRecords v-if="activeName === '3'" :value="detailsData" />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import request from '@/found/utils/request';
import BasicData from './basic_data.vue';
import MemberAssets from './member_assets.vue';
import OtherRecords from './Other_records.vue';

export default {
  name: 'additional',
  data() {
    return {
      activeName: '1',
      detailsData: {},
    };
  },
  components: {
    BasicData,
    MemberAssets,
    OtherRecords,

  },
  props: {
    formConfig: Object,
  },
  watch: {},
  created() {
    this.getPagelist();
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event)
      this.getPagelist();
    },
    // 获取详情
    getPagelist() {
      this.detailsData = {};
      const { row } = this.formConfig;
      if (row.id) {
        const params = {
          id: row.id,
        };
        const url = '/cps/v1/memberUserInfo/memberUserInfo/findById';
        request.get(url, params).then((res) => {
          if (res.success) {
            this.detailsData = res.result;
          }
        });
      }
    },
  },
};
</script>

<style lang="less" scoped></style>
